const users = {
  list: {
    title: 'Usuários',
    description: 'Gerencie os usuários administradores do backoffice.',
    mobileDescription: 'Gerencie os usuários administradores.',
    totalLabel: 'usuário(s)',
    create: 'Novo Usuário',
    searchPlaceholder: 'Buscar por nome ou e-mail...',
    emptySearchTitle: 'Nenhum resultado encontrado',
    emptyInitialTitle: 'Nenhum usuário cadastrado',
    emptySearchDescription:
      'Nenhum usuário corresponde aos critérios de busca. Tente ajustar os filtros.',
    emptyInitialDescription: 'Comece cadastrando o primeiro usuário administrador.',
    mobileEmptyMessage: 'Nenhum usuário encontrado.',
  },
  table: {
    name: 'Nome',
    lastAccess: 'Último acesso',
    status: 'Status',
    actions: 'Ações',
    neverAccessed: 'Nunca acessou',
    accessLocation: 'Localização do acesso',
  },
  status: {
    active: 'Ativo',
    pending: 'Pendente',
  },
  form: {
    createTitle: 'Novo Usuário',
    editTitle: 'Editar Usuário',
    createDescription: 'Preencha os dados para cadastrar um novo usuário administrador.',
    editDescription: 'Atualize as informações do usuário administrador.',
    loading: 'Carregando informações...',
    loadError: 'Não foi possível carregar as informações do usuário.',
    retry: 'Tentar novamente',
    nameLabel: 'Nome',
    emailLabel: 'E-mail',
    cancel: 'Cancelar',
    createSubmit: 'Cadastrar usuário',
    editSubmit: 'Salvar alterações',
    creating: 'Cadastrando...',
    saving: 'Salvando...',
  },
  actions: {
    resendActivation: 'Reenviar e-mail de ativação',
    delete: 'Excluir',
    deleteTitle: 'Excluir usuário',
    deleteDescription:
      'Tem certeza que deseja excluir o usuário "{{name}}"? Esta ação não pode ser desfeita.',
    deleteConfirm: 'Excluir',
    deleting: 'Excluindo...',
    resendTitle: 'Reenviar e-mail de ativação',
    resendDescription: 'Deseja reenviar o e-mail de ativação de conta para "{{name}}"?',
    resendConfirm: 'Reenviar',
    resending: 'Reenviando...',
  },
  toast: {
    createSuccess: 'Usuário cadastrado com sucesso',
    createError: 'Ocorreu um erro ao cadastrar o usuário',
    updateSuccess: 'Usuário atualizado com sucesso',
    updateError: 'Ocorreu um erro ao atualizar o usuário',
    deleteSuccess: 'Usuário excluído com sucesso',
    deleteError: 'Ocorreu um erro ao excluir o usuário',
    resendActivationSuccess: 'E-mail de ativação reenviado com sucesso',
    resendActivationError: 'Ocorreu um erro ao reenviar o e-mail de ativação',
  },
}

export default users
